







































import AddToHomeScreenHandler from '@/components/AddToHomeScreenHandler.vue'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import {TranslateResult} from 'vue-i18n'
import {Progress} from 'element-ui'
import {Component, Mixins, Watch, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import MenuLayout from './renewal/MenuLayout.vue'
import Error from '@/components/error/Error.vue'
import Toast from '@/components/Toast.vue'
import {highJackAjax, restoreAjax} from '@/lib/high-jack-ajax'
import {Institution, Status} from '@/store/modules/institutions/types'
import DialogDrawer from '@/components/DialogDrawer.vue'
import NoticeImg from '@/components/image/NoticeImg.vue'
import PopbillCertRegistrationPopup from '@/components/popup/btt/PopbillCertRegistration.vue'
import CertificateRegistrationPopup from '@/components/popup/page/CertificateRegistration.vue'
import DimLoading from '@/components/DimLoading.vue'
import toBr from '@/filters/to-br'
import {ALL_TOKENS_EXPIRED} from '@/store/modules/auth/constants'

const layout = namespace('layout')
const institutions = namespace('institutions')
const auth = namespace('auth')
const biz = namespace('biz')
const workflows = namespace('workflows')
const notice = namespace('notice')

/**
 * @displayName DefaultLayout
 */
@Component({
  components: {
    DimLoading,
    CertificateRegistrationPopup,
    PopbillCertRegistrationPopup,
    AddToHomeScreenHandler,
    MenuLayout,
    Error,
    Toast,
    DialogDrawer,
    NoticeImg,
    [Progress.name]: Progress,
  },
  filters: {toBr}
})
export default class DefaultLayout extends Mixins(Translation, PopupHandler) {
  @Prop({default: 'layout', type: String}) translation: string

  @layout.State('errors') errors: any[]
  @layout.Mutation('updateError') updateError: (id?: string, message?: string) => void
  @layout.Mutation('updateToast') updateToast
  @layout.Mutation('removeError') removeError: (id: string) => void
  @layout.State('toasts') toasts: any[]
  @layout.Mutation('removeToast') removeToast: (id: string) => void
  @layout.State('progressPercentage') progressPercentage: number
  @layout.State('routing') routing: boolean
  @institutions.Getter('approachExpiryCert') approachExpiryCert: Institution | null
  @institutions.Getter('popbillStatus') popbillStatus: Status
  @institutions.Action('getCertInstitutions') getCertInstitutions
  @auth.State('allTokensExpired') allTokensExpired: boolean
  @auth.Getter('hasPhone') hasPhone: boolean
  @auth.Getter('failbackSignIn') failbackSignIn: string
  @auth.Mutation('update') updateAuth: (payload: any) => void
  @biz.Getter('hasBiz') hasBiz: boolean
  @biz.State('id') bizId: string
  @workflows.State('loadingWorkflowStatus') loadingWorkflowStatus
  @notice.Getter('popupNotice') popupNotice
  @notice.Action('getNoticePopup') getNoticePopup

  openMenu: boolean = false
  pageAnimation: string = 'fade'
  windowScrollY: number = 0
  popupOpen: boolean = true
  isAnimation: boolean = false
  serviceName: string = ''

  get isSignUpUser(): boolean {
    return this.hasPhone && this.hasBiz && Boolean(this.bizId)
  }

  get certExpiresSoonError() {
    const limitDays = 7
    const {restExpiryDate = null} = this.approachExpiryCert || {}
    if(
      restExpiryDate !== null &&
      restExpiryDate <= limitDays &&
      restExpiryDate >= 0
    ) {
      const message: TranslateResult = this.tc('error.cert.expires-soon', restExpiryDate, {days: restExpiryDate})
      return {
        message,
          action: {
          kind: 'redirect',
            value: {
            name: 'certificates',
            query: {
              from: this.$route.name,
            },
          },
          afterClose: false,
        },
      }
    }
    return null
  }

  @Watch('$route')
  __$route(to, from) {
    const {pageLevel: toPageLevel = 1} = to.meta || {}
    const {pageLevel: fromPageLevel = 1} = from.meta || {}
    if(toPageLevel < fromPageLevel) {
      this.pageAnimation = 'slide-left'
      return
    }
    if(toPageLevel > fromPageLevel) {
      this.pageAnimation = 'slide-right'
      return
    }
    this.pageAnimation = 'fade'
  }

  @Watch('certExpiresSoonError', {immediate: true})
  __certExpiresSoonError(value) {
    const id = 'alert-cert-expiry'
    if(value) {
      this.updateError({
        id,
        ...value,
      })
    } else {
      this.removeError(id)
    }
  }

  @Watch('isSignUpUser', {immediate: true})
  __isSignUpUser(value) {
    if(value) {
      this.getCertInstitutions()
      this.getNoticePopup()
    }
  }

  @Watch('allTokensExpired')
  __allTokensExpired(value) {
    if(value) {
      this.updateToast({id: ALL_TOKENS_EXPIRED, message: '로그인 유효시간이 만료되었습니다.'})
      this.$router.replace({path: this.failbackSignIn, query: {then: this.$route.fullPath}})
        .then(() => {
          this.updateAuth({allTokensExpired: false})
        })
        .catch((err) => err)
    }
  }

  onLoading() {
    this.$Progress.start()
  }

  offLoading() {
    this.$Progress.finish()
  }

  errorLosing() {
    this.$Progress.fail()
  }

  offAppLoading() {
    const element = document.body.querySelector('#app-loading') as HTMLDivElement
    if(element) {
      element.style.opacity = '0'
      setTimeout(() => {
        element.style.display = 'none'
      }, 1000)
    }
  }

  mounted() {
    highJackAjax({
      start: this.onLoading,
      stop: this.offLoading,
      error: this.errorLosing,
    })
    this.offAppLoading()
      this.$nextTick(() => {
        window.addEventListener('scroll', this.onWindowScroll)
      })
  }

  beforeDestroy() {
    restoreAjax({
      start: this.onLoading,
      stop: this.offLoading,
      error: this.errorLosing,
    })
    window.removeEventListener('scroll', this.onWindowScroll)
  }


  onWindowScroll() {
    this.windowScrollY = Math.ceil(window.pageYOffset) || 0
  }

  onMenu() {
    this.openMenu = !this.openMenu
  }

  onTo(name: string) {
    if(name === 'issue' && this.popbillStatus !== 'success') {
      this.openPopup('popbillCert')
    } else {
      this.$router.push({name}).catch((err) => err)
    }
  }

  onAct(id, action) {
    const {afterClose = true} = action
    if(afterClose) {
      this.removeError(id)
    }
    switch(action.kind) {
      case 'redirect':
        // eslint-disable-next-line no-case-declarations
        const route = action.value || 'main'
        return this.$router
          .push(route)
          .catch((err) => err)
      case 'refresh':
        return this.$refreshPage('error', true)
      // no default
    }
  }

  onCertRegister(serviceName) {
    this.serviceName = serviceName
    this.openPopup('certRegister')
  }

  onCloseCerRegister() {
    this.closePopup('certRegister')
    this.serviceName = ''
    this.getCertInstitutions()
  }

  onBeforeEnter() {
    this.isAnimation = true
  }

  onAfterLeave() {
    this.isAnimation = false
  }

}
